import { saveDocumentAndWait } from "@/taskpane/utility/saveDocumentAndWait";

// Closing the current document with the default behavior makes Word save it on close, and that save
// rewrites the package without the add-in's auto-open parts, so the version never auto-opens again.
// Save explicitly only if it has unsaved changes, then close without a second save.
async function isDocumentSaved() {
  return Word.run(async (context) => {
    context.document.load("saved");
    await context.sync();
    return context.document.saved;
  });
}

export async function launchDocument(documentLink) {
  if (!documentLink) return;
  let saved = await isDocumentSaved();
  if (!saved) {
    saved = await saveDocumentAndWait();
  }
  await Word.run(async (context) => {
    context.application.openDocument(documentLink);
    // skipSave only when Word confirmed everything is saved; on a save timeout, fall back to the default
    // save-on-close so the user's edits are never discarded.
    context.document.close(saved ? Word.CloseBehavior.skipSave : Word.CloseBehavior.save);
    await context.sync();
  });
}
